import React, { useState } from 'react';
import JobsPageItem from './JobsItem';
import JobDeveloperWebsite from "./JobDeveloperWebsite"
import JobDeveloperCSharp from "./JobDeveloperCSharp"
import JobHiwiNetwork from "./JobHiwiNetwork"
import JobPhotographer from "./JobPhotographer"
import JobFinance from "./JobFinance"
import { FormattedMessageWrappedInSpan } from '../../../components/misc';

const JobsPage = () => {

  const [showJob, setShowJob] = useState(false);
  const [job, setJob] = useState("nix");


  return (
    <>
      <div className="social-buttons-container container-960 container-full-width">
        <div className="row">
          <JobsPageItem
            image="https://www.sportograf.com/images/elixir.png"
            JobComponent={JobDeveloperWebsite}
            jobType="developerWebsite"
            showJob={showJob}
            setShowJob={setShowJob}
            setJob={setJob}
            job={job}
            title={<FormattedMessageWrappedInSpan
              id="jobsPage.developerWebsite.title"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            intro={<FormattedMessageWrappedInSpan
              id="jobsPage.developerWebsite.intro"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            button={<FormattedMessageWrappedInSpan
              id="jobsPage.developerWebsite.showJob"
              defaultMessage="Show Job"
            />}
          />
          <JobsPageItem
            image="https://www.sportograf.com/images/csharp.png"
            JobComponent={JobDeveloperCSharp}
            jobType="developerCSharp"
            showJob={showJob}
            setShowJob={setShowJob}
            setJob={setJob}
            job={job}
            title={<FormattedMessageWrappedInSpan
              id="jobsPage.developerCSharp.title"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            intro={<FormattedMessageWrappedInSpan
              id="jobsPage.developerCSharp.intro"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            button={<FormattedMessageWrappedInSpan
              id="jobsPage.developerCSharp.showJob"
              defaultMessage="Show Job"
            />}

            />
          <JobsPageItem
            image="https://www.sportograf.com/images/hiwiNetwork.png"
            JobComponent={JobHiwiNetwork}
            jobType="hiwiNetwork"
            showJob={showJob}
            setShowJob={setShowJob}
            setJob={setJob}
            job={job}
            title={<FormattedMessageWrappedInSpan
              id="jobsPage.hiwiNetwork.title"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            intro={<FormattedMessageWrappedInSpan
              id="jobsPage.hiwiNetwork.intro"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            button={<FormattedMessageWrappedInSpan
              id="jobsPage.hiwiNetwork.showJob"
              defaultMessage="Show Job"
            />}
          />
          <JobsPageItem
            image="https://www.sportograf.com/images/photographer.png"
            JobComponent={JobPhotographer}
            jobType="photographer"
            showJob={showJob}
            setShowJob={setShowJob}
            setJob={setJob}
            job={job}
            title={<FormattedMessageWrappedInSpan
              id="jobsPage.photographer.title"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            intro={<FormattedMessageWrappedInSpan
              id="jobsPage.photographer.intro"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            button={<FormattedMessageWrappedInSpan
              id="jobsPage.photographer.showJob"
              defaultMessage="Show Job"
            />}
          />
          <JobsPageItem
            image="https://www.sportograf.com/images/finance.png"
            JobComponent={JobFinance}
            jobType="finance"
            showJob={showJob}
            setShowJob={setShowJob}
            setJob={setJob}
            job={job}
            title={<FormattedMessageWrappedInSpan
              id="jobsPage.finance.title"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            intro={<FormattedMessageWrappedInSpan
              id="jobsPage.finance.intro"
              defaultMessage="Placeholder"
              values={{ br: <br /> }}
            />}
            button={<FormattedMessageWrappedInSpan
              id="jobsPage.finance.showJob"
              defaultMessage="Show Job"
            />}
          />
        </div>
      </div>
    </>
  );
}

export default JobsPage;
